import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { sldierListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function SliderList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [slierData, setSliderData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getUser = async (params) => {
    const path = "admin/sliders";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setSliderData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getUser({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getUser(allFilter);
  };

  const data = [];

  slierData?.map((item) =>
    data.push({
      ...item,
      faPart: utils?.SLIDER_PART[item?.part]?.name || "",
      faPosition: utils?.SLIDER_POSITION[item?.position]?.name || "",
      key: item._id,
      id: item._id,
      createdAt: "1403",
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editUser = (singleUser) => {
    navigate("/edit-slider", { state: singleUser });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست اسلایدر ها"} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={sldierListColumns} rows={data} onEdit={editUser} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
